import React from 'react';
import { connect } from 'react-redux';
import { DBDropDownObjective, DBTextAreaObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationGaitAbnormalGait extends React.Component {

    render() {
        let dropdownOptions = [
            { id: 'Observed', value: 'Observed' },
            { id: 'Not Observed', value: 'Not Observed' }
        ];

        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Gait - Abnormal Gait Qualities' />
                    <label className={styles.label_wide}>Abnormal Gait Qualities</label>
                </div>
                <div className={styles.dropdown_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent_wide}>Step Length</label>
                    <DBDropDownObjective noteId={this.props.noteId} entity='PTOBJECTIVEOBS' entityKeyColumn='OONO' entityKeyValue={this.props.oono} field='OOGAIABNORMSTEPLENGTH' className={styles.dropdown} customOptions={dropdownOptions} />
                </div>
                <div className={styles.dropdown_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent_wide}>Step Width</label>
                    <DBDropDownObjective noteId={this.props.noteId} entity='PTOBJECTIVEOBS' entityKeyColumn='OONO' entityKeyValue={this.props.oono} field='OOGAIABNORMSTEPWIDTH' className={styles.dropdown} customOptions={dropdownOptions} />
                </div>
                <div className={styles.dropdown_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent_wide}>Cadence</label>
                    <DBDropDownObjective noteId={this.props.noteId} entity='PTOBJECTIVEOBS' entityKeyColumn='OONO' entityKeyValue={this.props.oono} field='OOGAIABNORMCADENCE' className={styles.dropdown} customOptions={dropdownOptions} />
                </div>
                <div className={styles.dropdown_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent_wide}>Wide Base of Support</label>
                    <DBDropDownObjective noteId={this.props.noteId} entity='PTOBJECTIVEOBS' entityKeyColumn='OONO' entityKeyValue={this.props.oono} field='OOGAIABNORMWIDEBASE' className={styles.dropdown} customOptions={dropdownOptions} />
                </div>
                <div className={styles.dropdown_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent_wide}>Narrow Base of Support</label>
                    <DBDropDownObjective noteId={this.props.noteId} entity='PTOBJECTIVEOBS' entityKeyColumn='OONO' entityKeyValue={this.props.oono} field='OOGAIABNORMNARROWBASE' className={styles.dropdown} customOptions={dropdownOptions} />
                </div>
                <div className={styles.dropdown_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent_wide}>Vaulting</label>
                    <DBDropDownObjective noteId={this.props.noteId} entity='PTOBJECTIVEOBS' entityKeyColumn='OONO' entityKeyValue={this.props.oono} field='OOGAIABNORMVAULTING' className={styles.dropdown} customOptions={dropdownOptions} />
                </div>
                <div className={styles.dropdown_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent_wide}>Calcaneal Whip</label>
                    <DBDropDownObjective noteId={this.props.noteId} entity='PTOBJECTIVEOBS' entityKeyColumn='OONO' entityKeyValue={this.props.oono} field='OOGAIABNORMCALCANEAL' className={styles.dropdown} customOptions={dropdownOptions} />
                </div>
                <div className={styles.dropdown_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent_wide}>Trendelenburg</label>
                    <DBDropDownObjective noteId={this.props.noteId} entity='PTOBJECTIVEOBS' entityKeyColumn='OONO' entityKeyValue={this.props.oono} field='OOGAIABNORMTRENDELBURG' className={styles.dropdown} customOptions={dropdownOptions} />
                </div>
                <div className={styles.dropdown_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent_wide}>Pelvic Rotation</label>
                    <DBDropDownObjective noteId={this.props.noteId} entity='PTOBJECTIVEOBS' entityKeyColumn='OONO' entityKeyValue={this.props.oono} field='OOGAIABNORMPELVICROT' className={styles.dropdown} customOptions={dropdownOptions} />
                </div>
                <div className={styles.dropdown_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent_wide}>Hyperextension</label>
                    <DBDropDownObjective noteId={this.props.noteId} entity='PTOBJECTIVEOBS' entityKeyColumn='OONO' entityKeyValue={this.props.oono} field='OOGAIABNORMHYPEREX' className={styles.dropdown} customOptions={dropdownOptions} />
                </div>
                <div className={styles.dropdown_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent_wide}>Femoral Rotation</label>
                    <DBDropDownObjective noteId={this.props.noteId} entity='PTOBJECTIVEOBS' entityKeyColumn='OONO' entityKeyValue={this.props.oono} field='OOGAIABNORMFEMORALROT' className={styles.dropdown} customOptions={dropdownOptions} />
                </div>
                <div className={styles.dropdown_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent_wide}>Foot Drop</label>
                    <DBDropDownObjective noteId={this.props.noteId} entity='PTOBJECTIVEOBS' entityKeyColumn='OONO' entityKeyValue={this.props.oono} field='OOGAIABNORMFOOTDROP' className={styles.dropdown} customOptions={dropdownOptions} />
                </div>
                <div className={styles.textarea_row}>
                    <span className={styles.flag} />
                    <label className={styles.textarea_sublabel_indent}>Comments</label>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOGAIABNORMCOMMENTS'
                        className={styles.textarea}
                    />
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMSTEPLENGTH ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMSTEPWIDTH ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMCADENCE ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMWIDEBASE ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMNARROWBASE ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMVAULTING ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMCALCANEAL ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMTRENDELBURG ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMPELVICROT ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMHYPEREX ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMFEMORALROT ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMFOOTDROP ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMOTHER ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOGAIABNORMCOMMENTS
            ? true : false
    };
}

const connectedObservationGaitAbnormalGait = connect(mapStateToProps)(ObservationGaitAbnormalGait);
export { connectedObservationGaitAbnormalGait as ObservationGaitAbnormalGait };


